module.exports = __webpack_public_path__ + "img/ortopedia-nacional.689dcc74.gif";